<template>
  <div>
    <p>© 2003-2020 慧源创新科技  Cloud 版权所有<span style="float: right">粤ICP备18095928号</span></p>
  </div>
</template>

<script>
export default {
  name: 'MainFoot'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainFoot.vue